import { makeStyles } from '@material-ui/core/styles';
export const useFormMediaFileStyles = makeStyles(theme => ({
  form: {
    flexGrow: 1
  },
  container: {
    width: '35rem'
  }
}));
